const delivery_methods = [
  "Kurier międzynarodowy",
  "Kurier GLS",
  "Kurier DHL",
  "Allegro Kurier DHL",
  "Allegro Kurier DHL (AD)",
  "Allegro Automaty Paczkowe DHL Węgry",
  "Allegro Odbiór w Punkcie DHL Węgry",
  "Allegro Odbiór w Punkcie DHL Słowacja",
  "Allegro Automaty Paczkowe DHL Słowacja",
  "Allegro Odbiór w Punkcie DHL",
  "Allegro Odbiór w Punkcie DHL (AD)",
  "Allegro Automat DHL POP BOX",
  "Allegro Automat DHL BOX 24/7 (AD)",
  "Kurier UPS",
  "Allegro Kurier UPS",
  "Allegro Odbiór w Punkcie UPS",
  "Kurier DPD",
  "Allegro Kurier DPD",
  "eMAG Kurier",
  "eMAG Easybox",
  "Allegro Odbiór w Punkcie DPD Pickup",
  "Allegro Kurier DPD (AD)",
  "Allegro Odbiór w Punkcie DPD Pickup (AD)",
  "Allegro Automaty Paczkowe DPD (AD)",
  "Paczkomaty InPost",
  "Allegro Paczkomaty InPost",
  "Erli Paczkomaty InPost",
  "Kurier InPost",
  "Allegro Kurier24 InPost",
  "Allegro miniKurier24 InPost",
  "Erli Kurier InPost - 30 kg",
  "Erli Kurier InPost - 10 kg",
  "Allegro Automaty Paczkowe Packeta",
  "Allegro Odbiór w Punkcie Packeta",
  "Allegro Odbiór w Punkcie Pocztex",
  "Allegro Automat Pocztex",
  "Allegro One Kurier",
  "Allegro One Box",
  "Allegro One Box, One Kurier",
  "Allegro One Box, UPS",
  "Allegro One Box, DPD",
  "Allegro One Box, DHL",
  "Allegro One Punkt",
  "Allegro One Punkt, UPS",
  "Allegro One Punkt, DPD",
  "Allegro One Punkt, One Kurier",
  "Allegro International Kurier",
  "Allegro International Odbiór w Punkcie",
  "Allegro International Automaty Paczkowe",
  "Allegro International Odbiór w Punkcie, One",
  "Allegro International Automaty Paczkowe, One",
  "Allegro International Kurier, One",
];

const delivery_methods_options = delivery_methods.map((method) => ({
  label: method,
  value: method,
}));

export default delivery_methods_options;
